const BLOG_STATIC_DIR = '__blogImages';

module.exports = {
  BLOG_STATIC_DIR,
};
